module.exports = __webpack_public_path__ + "db4ec4927c9ee5a35fea9480a8574da1.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/remove/remove-group.html
// module id = 2185
// module chunks = 0